module.exports = __webpack_public_path__ + "static/media/cta-illustration.3ce357e7.svg";